/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles/base-product-tiles.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const ProductTilesFragment = gql`
  ${BaseLinkFragment}
  ${BaseProductTilesFragment}

  fragment ProductTilesFragment on ProductTiles {
    ...BaseProductTilesFragment

    cta {
      ...BaseLinkFragment
    }
  }
`;
